"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMAIL_REGX = exports.fetchDummyData = exports.validateEmail = exports.moneyToDisplayPrice = void 0;
const navgatorLang = typeof window !== 'undefined' ? window.navigator.language : undefined;
const moneyToDisplayPrice = (money, locale) => {
    const currentLocale = locale || navgatorLang || 'en-US';
    const displayPrice = new Intl.NumberFormat(currentLocale, {
        style: 'currency',
        currency: money.currencyCode,
        currencyDisplay: 'narrowSymbol',
    }).format((money?.centAmount ?? 0) / Math.pow(10, money?.fractionDigits ?? 2));
    return displayPrice;
};
exports.moneyToDisplayPrice = moneyToDisplayPrice;
const validateEmail = (email) => {
    const regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    return regex.test(email);
};
exports.validateEmail = validateEmail;
// delays the function call for 2 seconds
const fetchDummyData = async (data) => {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve(data);
        }, 2000);
    });
};
exports.fetchDummyData = fetchDummyData;
exports.EMAIL_REGX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
